import styled from 'styled-components';
import { Anchor } from 'Components/core';

import { colors } from '../../constants';

const Button = styled(Anchor).attrs(props => ({ underline: false }))`
  padding: ${props => (props.wide ? '12px 36px' : '12px 24px')};
  color: ${props =>
    props.secondary ? colors.buttonBackground : colors.textOnAccent};
  background-color: ${props =>
    props.secondary ? 'transparent' : colors.buttonBackground};
  outline: none;
  border: 2px solid ${colors.buttonBackground};
  transition: 0.2s all;
  cursor: pointer;
  text-align: center;

  :hover {
    background-color: ${props =>
      props.secondary ? colors.buttonBackground : 'transparent'};
    color: ${props =>
      props.secondary ? colors.text : colors.buttonBackground};
  }
`;

export default Button;
